var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessActivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 408,
    height: 400,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.03 250.698c.996.743 37.329-3.529 37.329-3.529l10.43-38.03c.862-3.141-1.576-6.215-4.831-6.091l-41.419 1.567a4.82 4.82 0 00-4.488 3.62l-9.056 35.339-18.528 3.595 30.563 3.529z",
    fill: "#B3E0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.411 243.119H145.76l8.029-33.753 41.782-.923-9.16 34.676z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.031 254.5h118.4c0 5.901-4.783 10.683-10.683 10.683h-43.754l-1.297 112.693 18.939.263c3.748.052 6.936 2.482 8.319 5.916h-61.448c1.264-3.847 4.73-6.588 8.782-6.532l17.181.239 1.296-112.579h-45.053c-5.9 0-10.682-4.782-10.682-10.683z",
    fill: "#3A3B39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.783 257.444h148.895v-10.349H136.783v10.349z",
    fill: "#7DB1A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.477 239.677a3.356 3.356 0 01-3.352 3.352h-.037v-9.301h.037a3.356 3.356 0 013.352 3.353v2.596zm-3.352-8.71h-.037v-1.99h-15.455v17.251c0 .857.695 1.553 1.552 1.553h12.351c.857 0 1.552-.696 1.552-1.553v-.438h.037a6.121 6.121 0 006.114-6.113v-2.596a6.12 6.12 0 00-6.114-6.114z",
    fill: "#E73A5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.473 381.74c2.758-.126 5.224-.065 6.919.202 2.168.342 4.764 1.443 5.37 3.225.483.145 1.027.301 1.61.468 3.78 1.086 9.176 2.636 10.127 4.531 1.032 2.057.105 5.017-2.071 5.766-2.223.766-4.869-1.43-4.527-3.755.23-1.557 1.724-2.668 3.26-2.823l-8.605-2.111c-.822 1.468-2.996 2.082-4.838 2.371-4.19.656-8.421 1.191-12.659 1.391l-.754 2.6c.944-.873 2.002-.91 2.873-.47 1.29.653 2.17 2.353 1.657 3.935-1.4 4.331-6.581 1.858-7.097-1.507-.052-.338.278-2.78.696-4.48a62.981 62.981 0 01-5.58-.17l-.181-.014c-1.575-.119-3.258-.246-4.498-1.171-.914-.681-1.369-1.328-1.446-1.937l-6.371 1.563c1.535.155 3.03 1.266 3.259 2.823.342 2.325-2.304 4.521-4.527 3.755-2.176-.749-3.102-3.709-2.071-5.766.95-1.895 6.348-3.445 10.127-4.53.761-.219 1.457-.419 2.037-.599.503-.246 1.07-.479 1.69-.701l.033-.06a.146.146 0 01-.03.06c2.731-.975 6.485-1.707 10.248-2.153v-52.568a2.675 2.675 0 115.349 0v52.125z",
    fill: "#3A3B39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.835 312.597s-7.556 20.633-48.95 16.463c-41.392-4.169-19.364-22-4.523-22 14.84 0 53.473 5.537 53.473 5.537z",
    fill: "#523B5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.136 187.763s-1.268-9.629 0-9.629c1.266 0 2.28 4.815 2.28 4.815s4.942-9.377 5.575-9.124c.633.254-2.787 8.87-2.787 8.87s4.815-8.489 5.448-8.363c.634.127-3.421 9.503-3.421 9.503s4.307-7.095 4.815-6.968c.507.126-3.042 7.729-3.042 7.729s4.309-5.069 4.816-4.942c.507.127-1.141 4.308-9.884 12.924l-3.8-4.815z",
    fill: "#F9B6A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.617 182.731l3.802 3.548-.406.435-3.802-3.548.406-.435z",
    fill: "#CC395D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.16 203.643l24.071-16.047 4.458 5.646-21.397 24.666-7.132-14.265z",
    fill: "#0080A3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.364 374.817l-6.241 15.156 17.236-2.972-7.132-4.606 5.052-9.955-8.915 2.377zM93.24 373.097l-6.634 16.716 15.997-2.122-5.914-3.98 5.914-10.614h-9.364z",
    fill: "#FB9300"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.487 309.699L90.32 375.75l12.283-1.204 34.684-70.457-26.8 5.61z",
    fill: "#CC395D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.568 286.556s2.675 40.119 44.874 35.661c42.199-4.458 77.86-11.293 77.86-11.293L120.5 377.789l14.264-3.269s41.605-74.039 26.152-86.202c-15.453-12.163-66.568-6.814-66.568-6.814l-75.78 5.052z",
    fill: "#E73A5E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.607 124.99s3.764.792 4.359 6.142c.594 5.349 2.498 10.698 2.498 10.698l-2.498 1.982s1.982 7.132-1.783 8.321l-2.576.99v4.755l-14.246 1.981.774-8.915 3.566-20.803 9.906-5.151z",
    fill: "#F9B6A8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.136 150.944s-2.775-23.576 2.18-25.359c4.952-1.784 10.301-3.615 10.301-3.615s2.18-5.301 5.746-4.706c3.566.594 2.772 8.915-3.765 10.698-6.538 1.783-4.685 12.481-4.685 12.481s-2.843-3.764-4.23-1.188c-1.386 2.576 2.18 4.557 3.368 5.151v4.358l-8.915 2.18zM60.966 143.812s-4.457.891-5.349 5.844c0 0 7.826-1.09 5.35-5.844z",
    fill: "#523B5D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.291 136.679a1.089 1.089 0 10-2.177 0 1.089 1.089 0 002.177 0zM55.112 134.937a.445.445 0 01-.323-.753c1.018-1.073 2.689-1.438 4.064-.89a.446.446 0 01-.331.828c-1.026-.411-2.325-.126-3.088.676a.443.443 0 01-.322.139z",
    fill: "#3A3B39"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.72 143.44a.3.3 0 01-.208-.085l-2.95-2.895a.297.297 0 01.416-.424l2.95 2.894a.297.297 0 01-.207.51z",
    fill: "#CC395D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.243 183.733s3.269-26.981 31.478-26.981c35.68 0 49.948 70.071 64.213 87.605l36.85-5.944 2.971 9.213s-54.086 29.123-67.756 5.646l5.35 28.232s-62.408 10.995-75.78 5.052c0 0-2.081-80.238 2.674-102.823z",
    fill: "#00AEC8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 253.272l-15.453-25.854 17.407 36.167L89 253.272z",
    fill: "#0080A3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.303 310.924l9.807-1.783-11.403 6.913 1.596-5.13z",
    fill: "#CC395D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.783 238.413l8.321-1.486 8.321 2.972v2.675h-8.321l-6.034 2.927-2.287-7.088z",
    fill: "#F9B6A8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.148 320.919C4.182 300.157 11.72 254.353 12.04 252.421a2.08 2.08 0 014.104.68c-.075.455-7.219 45.566 9.181 65.131 7.408 8.839 21.956 10.838 21.956 10.838s-14.151 4.539-25.133-8.151z",
    fill: "#3A3B39"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.18 231.422c-4.64-2.262-10.078-1.671-15.24-1.714-4.001-.034-8-.483-11.909-1.338-2.01-.439-4.175-.973-6.058-.143-2.603 1.147-3.506 4.332-3.994 7.134-.898 5.153-1.434 10.46-.458 15.599 3.995 21.026 38.489 17.251 44.681-.291 2.51-7.043-.302-15.971-7.023-19.247zM93.805 0h192.57c5.252 0 9.51 4.258 9.51 9.51v150.965a9.51 9.51 0 01-9.51 9.51H93.805a9.51 9.51 0 01-9.51-9.51V9.51A9.51 9.51 0 0193.805 0z",
    fill: "#523B5D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.693 141.928a1.486 1.486 0 010-2.972H231.5a1.487 1.487 0 010 2.972h-40.807zm-87.531.027a1.485 1.485 0 110-2.971h40.807a1.486 1.486 0 010 2.971h-40.807zm1.288 9.284a1.486 1.486 0 110-2.972h44.246a1.486 1.486 0 010 2.972H104.45zm-1.487 7.826c0 .821.665 1.486 1.486 1.486h30.014a1.486 1.486 0 000-2.972h-30.014c-.821 0-1.486.665-1.486 1.486zm86.244-9.312c0 .821.665 1.486 1.486 1.486h32.673a1.486 1.486 0 100-2.972h-32.673c-.821 0-1.486.666-1.486 1.486zm1.486 10.798a1.486 1.486 0 110-2.972h44.247a1.486 1.486 0 110 2.972h-44.247z",
    fill: "#B3E0D0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.676 128.006H247.09v-2.972H104.648v-15.039l.46.46 33.396-33.395v26.56l57.943-57.945v31.558h27.568V74.26h-24.596V38.5l-57.944 57.945v-26.56l-36.827 36.828V25.759h-2.972v102.247z",
    fill: "#E73A5E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.75 113.769l-1.605-.401a4.401 4.401 0 01-3.337-4.369c.119-5.204.594-15.078 2.439-22.072 2.615-9.91-5.366-10.735-8.119-11.215-2.753-.48-9.221 9.425-9.909 10.251-.688.826 1.101 2.202 1.101 2.202s-.963 3.716-1.789 6.33c-.826 2.616 4.266 4.955 4.266 4.955l-.462 5.877c-.215 2.753-3.312 4.453-6.811 3.362-8.044 14.18 18.65 28.057 24.226 5.08z",
    fill: "#F9B6A8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.002 112.862c-3.079 8.856-14.392 13.861-21.87 6.383-3.083-2.57-3.056-6.472-2.607-10.556-.311-.018-2.742-.562-2.742-.562s-7.43 14.536 10.698 20.479c18.128 5.944 23.626-13.967 23.626-13.967l-7.105-1.777z",
    fill: "#FFFFFE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.503 370.279l1.34 9.593-9.173 6.389h19.871l-.506-15.783c-3.844.062-7.687-.032-11.532-.199z",
    fill: "#E73A5E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.035 370.478l-1.582-49.37 9.815-57.334h-25.557l-1.608 39.729a119.068 119.068 0 001.048 21.29l6.352 45.486c3.845.167 7.688.261 11.532.199z",
    fill: "#F9B6A8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.041 369.107l1.502 10.765-9.172 6.389h19.871l-.543-16.929c-3.887-.174-7.772-.279-11.658-.225z",
    fill: "#E73A5E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.969 263.774h-25.557l-1.66 41.04c-.253 6.242.054 12.493.918 18.68l6.371 45.613c3.887-.055 7.772.051 11.659.224l-1.547-48.223 9.816-57.334zM304.329 99.037S260.25 61.99 243.014 37.622l-6.34-11.293-3.608 1.993 3.409 11.876-4.474-1.616-1.46 1.105 7.898 5.498s27.257 44.448 58.758 72.032l7.132-18.18z",
    fill: "#F9B6A8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.333 273.331l1.636-9.556h-25.557l-.387 9.556h24.308zM361.632 273.331l1.636-9.556h-25.557l-.387 9.556h24.308z",
    fill: "#F7A8A2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.329 99.037l-7.132 18.18 3.804 3.789c2.603-6.478 4.906-13.071 7.055-19.777l-3.727-2.192z",
    fill: "#FFFFFE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.954 152.529l9.51-2.08c.297-35.81-24.448-36.833-24.448-36.833-4.911 21.522-35.412 15.949-30.233-5.489l-11.726-6.898c-2.149 6.706-4.452 13.299-7.055 19.777l9.272 9.235c-1.486 11.292-11.887 140.267-11.887 140.267h77.86c1.189-12.778-11.293-117.979-11.293-117.979z",
    fill: "#00A650"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.154 260.074l46.131-10.364 6.703 32.128-43.902 12.33-8.932-34.094z",
    fill: "#7DB1A1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.363 260.998l45.171-13.967 9.213 31.501-42.794 15.75-11.59-33.284z",
    fill: "#B3E0D0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.764 254.343l6.841 24.696 1.356-.581-6.84-24.695-1.357.58zm.985 26.749l-6.84-24.695 1.356-.581 6.84 24.696-1.356.58zm-12.697-22.642l6.841 24.696 1.355-.581-6.84-24.695-1.356.58zm.984 26.75l-6.84-24.696 1.356-.58 6.84 24.695-1.356.581zm-5.856 2.053l-6.84-24.695 1.356-.581 6.84 24.696-1.356.58z",
    fill: "#7DB1A1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.463 150.449l6.278 39.225a114.544 114.544 0 012.043 23.182c-.14 10.191-1.913 31.22-1.478 38.687l-1.874 11.239-4.188 1.188v-9.46l-3.898.891 2.225-7.181-2.951-45.468-9.679-49.629 13.522-2.674z",
    fill: "#F9B6A8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.942 153.123l-.643-4.557 13.961-2.433.501 4.761-13.819 2.229z",
    fill: "#FFFFFE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.292 96.362c-1.062-1.874-3.218-2.924-4.297-4.788-1.985-3.427.415-7.965-.966-11.678-.773-2.077-2.602-3.547-4.351-4.909-2.493-1.942-5.521-4-8.558-3.125-2.469.71-4.108 3.544-3.492 6.039.665 2.693 3.398 4.425 4.334 7.037.553 1.543.378 3.316-.414 4.747.537-.55 1.502-.695 2.182-.28.848.518 1.178 1.67.902 2.625-.276.955-1.06 1.705-1.957 2.134-.897.43-1.902.574-2.895.638-1.625 3.673-1.08 8.281 1.549 11.317 2.629 3.038 7.068 4.372 10.936 3.288 3.868-1.083 6.967-4.528 7.637-8.489.26-1.54.16-3.196-.61-4.556z",
    fill: "#E73A5E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.816 95.727a1.659 1.659 0 10-3.318 0 1.659 1.659 0 003.318 0z",
    fill: "#FFFFFE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.652 83.899a.964.964 0 10-1.928 0 .964.964 0 001.928 0zM335.38 83.121a.447.447 0 01-.432-.334c-.251-.977-1.343-1.702-2.344-1.551a.446.446 0 01-.133-.882c1.443-.217 2.976.795 3.341 2.21a.446.446 0 01-.432.558z",
    fill: "#3A3B39"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.205 92.913a.297.297 0 01-.215-.501 6.625 6.625 0 013.125-1.844.294.294 0 01.361.213.296.296 0 01-.212.362 6.039 6.039 0 00-2.843 1.677.296.296 0 01-.216.094zM329.797 99.45l3.578 1.515-3.729.411.151-1.925z",
    fill: "#CC395D"
  })));
}
export default SvgBusinessActivate;